module.exports = __webpack_public_path__ + "img/realtime-sdk.69eb703.png";